import Component from '@glimmer/component';
import { service } from '@ember/service';
import ENV from 'donor-elf-web/config/environment';
import { action } from '@ember/object';

/*
  args
    - task
    - allFundsInfo
    - displayOneColumn
    - onTaskDeleted(task)
*/

export default class extends Component {
  constructor(owner, args) {
    super(owner, args);

    this.isSelectedFund =
      args.task.fundId === this.fundsService.selectedFund.id;
  }

  @service fundsService;
  @service taskService;

  get fundName() {
    return this.args.allFundsInfo.fundsById[this.args.task.fundId].name;
  }

  get rootUrl() {
    return ENV.rootURL;
  }

  @action
  handleTaskDeleted(task) {
    this.args.onTaskDeleted(task);
  }
}
